import { UEVRPLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "2a141953-a3a4-4842-9747-4a4d4bedbb1a",
    label: "KMC LEAFLET Front Page",
  },
  {
    fileStoreId: "aee0667c-93e9-4cb0-8e46-a01a6e1d5c2a",
    label: "KMC LEAFLET Back Page",
  },
];

const Earthquake_Leaflet = () => (
  <TableStructure
    title="Earthquake Leaflet"
    heading={false}
    list={List}
    columnNo={1}
    leftMenuList={UEVRPLeftMenuList}
    longMenuList={false}
  />
);

export default Earthquake_Leaflet;
